import React from 'react';
import { colors } from '@styleseat/brand';

// A view box that hugs the sides of the icon instead
// of setting it in a square
export const TIGHT_VIEW_BOX = '6 3 11 16';

type ArrowsChevronLeftIconProps = {
  width?: number;
  height?: number;
  viewBox?: string;
  color?: string;
  testID?: string;
} & React.SVGProps<SVGSVGElement>;

export const ArrowsChevronLeftIcon = ({
  width = 24,
  height = 24,
  viewBox = '0 0 24 24',
  color = colors.blackInBlack,
  testID,
}: ArrowsChevronLeftIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid={testID}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.41424 12L16.7071 19.2929L15.2929 20.7071L6.58582 12L15.2929 3.29291L16.7071 4.70712L9.41424 12Z"
      fill={color}
    />
  </svg>
);
